import { v4 } from "uuid";

export const guid = () => v4();
